import React from 'react';

import { InstructionStepNoIconType } from './types';

import './InstructionSteps.scss';

interface InstructionStepsNoIconProps {
    instructionStepsNoIcon: InstructionStepNoIconType[];
}

const InstructionStepsNoIcon = ({ instructionStepsNoIcon }: InstructionStepsNoIconProps) => (
    <section className="instruction-steps">
        {instructionStepsNoIcon.map(({ text }) => (
            <p key={text} className="sgw-expand-card__subtitle">
                {text}
            </p>
        ))}
    </section>
);

export default InstructionStepsNoIcon;
